const ArrowButton = ({ onClick, direction, visibleCondition }) => {
  return (
    <button
      onClick={onClick}
      style={{
        border: "none",
        background: "none",
        visibility: visibleCondition ? "visible" : "hidden",
        marginRight: direction == "left" && "12px",
        padding: "20px", // Increased touch area
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "15px",
          height: "15px",
          borderTop: "2px solid #BEBEBE", // 상단 선
          borderRight: "2px solid #BEBEBE", // 우측 선
          transform: direction === "left" ? "rotate(-135deg)" : "rotate(45deg)", // 45도 회전
        }}
      ></div>
    </button>
  );
};

export default ArrowButton;
